/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_TitleInputs */

const en_mail_compose_title = /** @type {(inputs: Mail_Compose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compose email`)
};

const de_mail_compose_title = /** @type {(inputs: Mail_Compose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail schreiben`)
};

/**
* | output |
* | --- |
* | "Compose email" |
*
* @param {Mail_Compose_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_title = /** @type {((inputs?: Mail_Compose_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_title(inputs)
	return en_mail_compose_title(inputs)
});